import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LinkService {
  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) {}

  setCanonicalUrl(path: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const ORIGIN = window.location.origin;
    const URL = ORIGIN + path;

    let linkEl: HTMLLinkElement | null = this.document.querySelector(`link[rel='canonical']`);
    if (!linkEl) {
      linkEl = this.document.createElement('link');
      linkEl.setAttribute('rel', 'canonical');
      this.document.head.appendChild(linkEl);
    }
    linkEl.setAttribute('href', URL);
  }
}
